import { ProductCardMode } from '@components/product/ProductCard/ProductCard'
import { Button } from '@components/ui'
import cn from 'clsx'

import throttle from 'lodash.throttle'
import { useTranslation } from 'next-i18next'
import { FC, useEffect } from 'react'
import { useInfiniteHits } from 'react-instantsearch'
interface props {
  HitComponent: any
  mode: any
  sessionStorageCache: any
  showLargeItems?: boolean
  sliderValue?: number
  mobileSliderValue?: number
}

const CustomInfiniteHits: FC<props> = ({
  HitComponent,
  mode,
  sessionStorageCache,
  showLargeItems,
  sliderValue,
  mobileSliderValue,
}) => {
  const { t } = useTranslation('common')
  const { hits, showMore, isLastPage, sendEvent } = useInfiniteHits({
    cache: sessionStorageCache,
  })
  const desktopColumns = () => {
    switch (sliderValue) {
      case 4:
        return 'lg:grid-cols-3'
      case 3:
        return 'lg:grid-cols-4'
      case 2:
        return 'lg:grid-cols-6'
      case 1:
        return 'lg:grid-cols-8'
      default:
        return 'lg:grid-cols-4'
    }
  }
  const mobileColumns = () => {
    switch (mobileSliderValue) {
      case 3:
        return 'grid-cols-1 gap-x-6'
      case 2:
        return 'grid-cols-2 gap-x-6'
      case 1:
        return 'grid-cols-3 gap-x-4'
      default:
        return 'grid-cols-2 gap-x-6'
    }
  }
  const handleScroll = throttle(() => {
    const scrollYPosition = window.scrollY
    sessionStorage.setItem('scrollPosition', scrollYPosition.toString())
  }, 500)
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  useEffect(() => {
    const scrollPosition = sessionStorage.getItem('scrollPosition')
    if (scrollPosition) {
      window.scrollTo(0, Number(scrollPosition))
    }
  }, [])
  return (
    <div>
      <div
        className={cn(
          `wrapper grid ${mobileColumns()} gap-y-6 pb-11 pt-4 lg:pt-10 ${desktopColumns()} lg:gap-x-8`
        )}
      >
        {hits.map((hit: any, index: number) => {
          // If remainder is 2 or 13 then show large image else small.
          const large =
            showLargeItems && (index % 26 === 2 || index % 26 === 13)
          const largeScreen =
            typeof window !== 'undefined' && window?.innerWidth >= 1024

          return (
            <div
              key={index}
              className={cn({ 'lg:col-span-2 lg:row-span-2': large })}
            >
              <HitComponent
                key={index}
                hit={hit}
                variant={large ? 'large' : 'small'}
                mode={large && largeScreen ? ProductCardMode.IMAGE : mode}
                smallestCard={
                  !largeScreen ? mobileSliderValue === 1 : sliderValue === 1
                }
                sendEvent={sendEvent}
              />
            </div>
          )
        })}
      </div>
      {!isLastPage && (
        <div className="my-6 flex justify-center">
          <Button variant="secondary" onClick={showMore} width="176px">
            {t('show-more')}
          </Button>
        </div>
      )}
    </div>
  )
}

export default CustomInfiniteHits
